import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const CriarContaPage = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background-color: #f5f5f5;
    padding: 2rem;
`

export const CriarContaCard = styled(Box)`
    width: 100%;
    max-width: 460px;
`
